import i18n from 'i18next';

export default () => [
  {
    icon: 'initiativeOnboarding',
    label: i18n.t('onboarding'),
    description: i18n.t('onboarding-description'),
    value: 'Onboarding',
  },
  {
    icon: 'initiativeEnablement',
    label: i18n.t('skills-and-enablement'),
    description: i18n.t('skills-and-enablement-description'),
    value: 'Enablement',
  },
  {
    icon: 'initiativeCertification',
    label: i18n.t('certification'),
    description: i18n.t('certification-description'),
    value: 'Certification',
  },
  {
    icon: 'initiativeCompliance',
    label: i18n.t('compliance'),
    description: i18n.t('compliance-description'),
    value: 'Compliance',
  },
  {
    icon: 'initiativeVideo',
    label: i18n.t('video-streaming'),
    description: i18n.t('video-streaming-description'),
    value: 'Video',
  },
  {
    icon: 'initiativeKnowledgeBase',
    label: i18n.t('knowledge-base'),
    description: i18n.t('knowledge-base-description'),
    value: 'Knowledge Base',
  },
];
